/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Y_Offset_LabelInputs */



/**
* | output |
* | --- |
* | "Y-Offset" |
*
* @param {Video_Filters_Y_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_y_offset_label = /** @type {((inputs?: Video_Filters_Y_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Y_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decalage Y")
	if (locale === "de") return /** @type {LocalizedString} */ ("Y-Offset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Y-Offset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Y-смещение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento Y")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Y轴偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Yオフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वाई ऑफसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento em Y")
	return /** @type {LocalizedString} */ ("Y-Offset")
});